<template>
  <v-form ref="form" @submit.prevent="reactivateClick">
    <PaymentMethodSelect
      dense outlined hide-details="auto"
      :rules="[ v => !!v || 'payment method required']"
      v-model="payment_method"
      label="Choose a card to reactivate"
      class="pt-2"
    />

    <div class="pt-3" style="font-size: 12px;">
      You can add a card by tapping the "+" next to Payment Methods
      on the previous page, if one doesn't exist.
    </div>

    <v-checkbox v-model="refill_enabled" dense hide-details class="mt-2 mb-4" :disabled="loading">
      <template #label>
          <div style="font-size: 12px; line-height: 1.25;">
            Enable auto-refill of your account.   You can adjust your settings on your auto-refill page.
          </div>
        </template>
    </v-checkbox>

    <v-divider class="my-4"/>

    <div class="d-flex justify-center mt-4 mb-2">
      <v-btn @click="$router.back()">Cancel</v-btn>
      <v-btn :disabled="loading" type="submit" color="primary" class="ml-2">
        Reactivate
      </v-btn>
    </div>
  </v-form> 
</template>

<script>
import { PaymentMethodSelect } from '@/components/inputs'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ReactiveateWithExisting',

  components: { PaymentMethodSelect },

  data: () => ({
    refill_enabled: true,
    paymentElement: null,
    secretLoaded: null,

    payment_method: null,

    // error handling
    loading: false,
  }),

  computed: {
    ...mapGetters('payment_methods', ['paymentSecret']),
  },

  methods: {
    ...mapActions('payment_methods', ['loadPaymentSecret']),
    ...mapActions('billing', ['reactivate']),

    async reactivateClick() {
      if (this.$refs.form.validate()) {
        const { payment_method, refill_enabled } = this
        const payload = { payment_method, refill_enabled }
        
        this.loading = true 
        const result = await this.reactivate(payload)
        this.loading = false

        if (result.ok) {
          this.$router.push('billing/account')
        } else {
          this.$emit('error', result.error)
        }
      }
    },
  },
}
</script>